import { render, staticRenderFns } from "./MilkVatChangeLog.vue?vue&type=template&id=1ce011c6&"
import script from "./MilkVatChangeLog.vue?vue&type=script&lang=ts&"
export * from "./MilkVatChangeLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports